<template>
  <div class="card-slot">
    <div
      class="content-card -flex -vcenter -vstretch -pointer"
      role="button"
      tabindex="0"
      @click="startTour"
      @keyup.enter="startTour"
    >
      <div
        class="type"
        :class="{
          '-green': iconColor === '-green',
        }"
        aria-hidden="true"
      >
        <i class="material-symbols-outlined fill" aria-hidden="true">{{ icon }}</i>
      </div>
      <spinner-loader v-if="loading" />
      <div v-if="!loading" class="summary">
        <h2 class="heading">{{ title }}</h2>
        <div class="desc">
          {{ desc }}
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { mapActions } from 'pinia'
import { useToursStore } from '@/stores/tours'
import SpinnerLoader from '@/components/loaders/spinner-loader.vue'

/**
 * TODO: gt comments
 */
export default defineComponent({
  name: 'TourCard',
  components: { SpinnerLoader },
  props: {
    url: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    iconColor: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      required: true,
    },
    desc: {
      type: String,
      required: true,
    },
    guidedTourId: {
      type: String,
      required: true,
    },
    tourId: {
      type: String,
      required: true,
    },
  },

  // component state
  data() {
    return {
      loading: false,
    }
  },

  // component methods
  methods: {
    ...mapActions(useToursStore, ['startGuidedTour']),

    async startTour() {
      if (this.loading) {
        return
      }

      this.loading = true

      await this.startGuidedTour({
        guidedTourId: this.guidedTourId,
        tourId: this.tourId,
      })

      window.location.href = this.url
    },
  },
})
</script>
